export default "__VITE_ASSET__cxcekoWM__"